export const DEFAULT_LOCALE = 'en-us';
export const DEFAULT_COUNTRY_CODE = 'US';
export const DEFAULT_CURRENCY_CODE = 'USD';
export const NEXT_LOCALE_COOKIE_NAME = 'locale_next';
export const SNEAKER_LOCALE_COOKIE_NAME = 'locale';

export enum LOCALES {
  enUS = 'en-us',
  enGB = 'en-gb',
  enCA = 'en-ca',
  frCA = 'fr-ca',
  enAU = 'en-au',
  frFR = 'fr-fr',
  enIT = 'en-it',
  enNL = 'en-nl',
  enSA = 'en-sa',
  enDE = 'en-de',
  enMX = 'en-mx',
  enAE = 'en-ae',
}

export const AVAILABLE_LOCALES = {
  [LOCALES.enUS]: {
    code: LOCALES.enUS,
    currency: 'USD',
    country: 'US',
    countryName: 'United States',
    label: 'English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enGB]: {
    code: LOCALES.enGB,
    currency: 'GBP',
    country: 'UK',
    countryName: 'United Kingdom',
    label: 'United Kingdom English',
    showVAT: true,
    locale: 'en',
  },
  [LOCALES.enCA]: {
    code: LOCALES.enCA,
    currency: 'CAD',
    country: 'CA',
    countryName: 'Canada',
    label: 'Canada English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.frCA]: {
    code: LOCALES.frCA,
    currency: 'CAD',
    country: 'CA',
    countryName: 'Canada',
    label: 'Canada French',
    showVAT: false,
    locale: 'fr',
  },
  [LOCALES.enAU]: {
    code: LOCALES.enAU,
    currency: 'AUD',
    country: 'AU',
    countryName: 'Australia',
    label: 'Australia English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.frFR]: {
    code: LOCALES.frFR,
    currency: 'EUR',
    country: 'FR',
    countryName: 'France',
    label: 'French',
    showVAT: false,
    locale: 'fr',
  },
  [LOCALES.enNL]: {
    code: LOCALES.enNL,
    currency: 'EUR',
    country: 'NL',
    countryName: 'Netherlands',
    label: 'Netherlands English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enIT]: {
    code: LOCALES.enIT,
    currency: 'EUR',
    country: 'IT',
    countryName: 'Italy',
    label: 'Italy English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enSA]: {
    code: LOCALES.enSA,
    currency: 'USD',
    country: 'SA',
    countryName: 'Saudi Arabia',
    label: 'Saudi Arabia English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enDE]: {
    code: LOCALES.enDE,
    currency: 'EUR',
    country: 'DE',
    countryName: 'Germany',
    label: 'Germany English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enMX]: {
    code: LOCALES.enMX,
    currency: 'MXN',
    country: 'MX',
    countryName: 'Mexico',
    label: 'Mexico English',
    showVAT: false,
    locale: 'en',
  },
  [LOCALES.enAE]: {
    code: LOCALES.enAE,
    currency: 'USD',
    country: 'AE',
    countryName: 'United Arab Emirates',
    label: 'United Arab Emirates English',
    showVAT: false,
    locale: 'en',
  },
};

export const AVAILABLE_LANGUAGES = Object.values(AVAILABLE_LOCALES).map((locale) => {
  return {
    code: locale.code,
    label: locale.label,
  };
});

export const COUNTRY_TO_LOCALE_MAP: { [key: string]: string } = {
  US: LOCALES.enUS,
  UK: LOCALES.enGB,
  GB: LOCALES.enGB,
  CA: LOCALES.enCA,
  AU: LOCALES.enAU,
  NL: LOCALES.enNL,
  IT: LOCALES.enIT,
  SA: LOCALES.enSA,
  DE: LOCALES.enDE,
  FR: LOCALES.frFR,
  MX: LOCALES.enMX,
  AE: LOCALES.enAE,
};

export const SUPPORTED_COUNTRIES = Object.values(AVAILABLE_LOCALES).map(
  (localeInfo) => localeInfo.country,
);

// French Locales are omitted from show editorials since they are not translated to French
export const OMITTED_EDITORIAL_LOCALES = [LOCALES.frFR, LOCALES.frCA];
